import { defaultContainerSize, mq } from '../../../styles/mixins';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  ${defaultContainerSize};
  margin-top: 4rem;
  margin-bottom: 4rem;

  ${mq.small(css`
    margin-top: 5rem;
    margin-bottom: 5rem;
  `)};
`;

export const Title = styled.h3`
  font-size: 2rem;
  line-height: 2.5rem;
  font-family: ${({ theme }) => theme.font.questrial};
  font-weight: 400;
  margin: 0 0 2.5rem 0;
  color: ${({ theme }) => theme.colors.core_black};

  ${mq.medium(css`
    font-size: 3rem;
    line-height: 3.5rem;
    letter-spacing: -0.0125rem;
  `)};
`;

export const PersonsList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;
